import { useState } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Header from "./Components/common/Header";
import "react-datepicker/dist/react-datepicker.css";
import "./Styles/4_Managementpage.css";
import TrendPanel from "./Components/Sidebar/Datatab/CropMonitoring/TrendPanel";
import DiseasePestPanel from "./Components/Sidebar/Datatab/CropMonitoring/DiseasePestPanel";

const theme = createTheme();

const ManagementPage = () => {
  // 메뉴 상태 추가
  const [isMenuActive, setIsMenuActive] = useState(false);

  // 메뉴 아이콘 클릭 핸들러 함수 추가
  const handleMenuicon = () => {
    setIsMenuActive((prev) => {
      const next = !prev; // 현재 상태를 반대로 토글
      console.log("[Menu] isMenuActive →", next);
      return next; // 새로운 상태 반환
    });
  };

  return (
    <ThemeProvider theme={theme}>
      {/* Header 컴포넌트에 필요한 props 전달 */}
      <Header onMenuicon={handleMenuicon} isMenuActive={isMenuActive} />

      {/* 메인 컨테이너 */}
      <main className="smart-farm-container main">
        {/* 오른쪽: 데이터 패널들을 이제 전체 화면에서 우측에 배치 */}
        <div className="data-panels">
          {/* NDVI / 기상요소 / 병해충 변화 추이 차트 패널 */}
          <TrendPanel />

          {/* 병해충 진단 패널 */}
          <DiseasePestPanel />
        </div>
      </main>
    </ThemeProvider>
  );
};

export default ManagementPage;
